import { useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

const ZendeskTicketingIntegrationPage = () => {
    const [searchParams] = useSearchParams();
    const broadcastChannel = useMemo(
        () => new BroadcastChannel("zendesk-oauth2-code"),
        [],
    );

    useEffect(() => {
        const code = searchParams.get("code");
        broadcastChannel.postMessage(code);
        window.close();
    }, [searchParams, broadcastChannel]);

    return <></>;
};

export default ZendeskTicketingIntegrationPage;
